import React, { useEffect, useState } from "react";
import PlanifTable from "../component/planifTable";
import ModalMessage from "../component/ModalMessage";
import "../App.less";
import {
  Form,
  Select,
  InputNumber,
  Switch,
  Radio,
  Slider,
  Button,
  Upload,
  Rate,
  Checkbox,
  Row,
  Col,
  message,
  Spin,
  Typography,
  Progress,
  BackTop,
} from "antd";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import {
  BackwardOutlined,
  ForwardOutlined,
  MailOutlined,
  SendOutlined,
  LoadingOutlined,
  CheckOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import { FaCloudUploadAlt, FaPrint } from "react-icons/fa";
import "../assets/styles/Planification.css";
import { UploadOutlined, InboxOutlined } from "@ant-design/icons";
import CustomLayout from "./CustomLayout";
import axios from "axios";
import { database, auth, functions } from "../modules/fireBase";
import Popup from "../component/Popup";
import dayjs from "dayjs";
import "dayjs/locale/fr";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { generatePdf } from "../modules/pdfGenerator";
dayjs.extend(customParseFormat);
dayjs.locale("fr");

const { Dragger } = Upload;
const { Title, Text } = Typography;

export default function Planification() {
  const [contactChantier, setContactChantier] = useState([]);
  const [contactBureau, setContactBureau] = useState([]);
  const [settings, setSettings] = useState([]);
  const [planifData, setPlanifData] = useState(undefined);
  const [planifDate, setPlanifDate] = useState(undefined);
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupCoordinates, setPopupCoordinates] = useState({ x: 0, y: 0 });
  const [actualRecord, setActualRecord] = useState(undefined);
  const [fileName, setFileName] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [modalMessageVisible, setModalMessageVisible] = useState(false);
  const [modalRecord, setModalRecord] = useState(undefined);
  const [percentage, setPercentage] = useState(0);
  const [sendingDone, setSendingDone] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const showPopup = (record, x, y) => {
    setActualRecord(record);
    setPopupCoordinates({ x: x, y: y });
    setPopupVisible(true);
    document.addEventListener(`click`, function onClickOutside() {
      setPopupVisible(false);
      document.removeEventListener(`click`, onClickOutside);
    });
  };
  const newPlanifDowloaded = (data) => {
    let newPlanifData = { ...data }.projectsperEmploye;
    let newPlanifDate = { ...data }.planifdate;
    let newSelectedRowKeys = [];
    newPlanifData.forEach((d, index) => {
      if (needToSelect(d)) {
        newSelectedRowKeys.push(d.key);
      }
      newPlanifData[index].message = buildMessage(d, newPlanifDate);
    });
    setPlanifData(newPlanifData);
    console.log(newPlanifData);
    setPlanifDate(newPlanifDate);
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const buildMessage = (d, planifdate) => {
    let date = dayjs(planifdate, "D MMMM YYYY");
    let message = `Bonjour ${d.prenom}, cédule du ${capitalize(
      date.format("dddd")
    )} ${date.format("DD")} ${capitalize(date.format("MMMM"))} :\n`;
    //Projects
    d.projects.forEach((project, index) => {
      if (project === "OFF") {
        message += "OFF\n";
        return;
      }
      if (project === "CONGÉ") {
        message += "CONGÉ\n";
        return;
      }
      if (project.projectname) {
        if (d.projects.length > 1) {
          message += `Projet ${index + 1}\n`;
        }
        if (d.direprojet && project.remarques !== "ANNULÉ") {
          message += `${project.projectname} \n`;
        }
        if (project.remarques === "ANNULÉ") {
          message += `CHANGEMENT : Le projet est ANNULÉ\n`;
        } else {
          message += `Départ : ${dayjs(project.depart, "HH:mm").format(
            "HH:mm A"
          )}${
            project.remarques.trim().length > 2 ? " - " + project.remarques : ""
          } \n`;
        }

        let indexphonenumber = contactBureau.findIndex(
          (contact) =>
            project.chargedeprojet === contact.prenom + " " + contact.nom
        );
        let phonenumberchargedeprojets =
          contactBureau[indexphonenumber].phonenumber;
        message += `Chargé de projets : ${project.chargedeprojet}${
          phonenumberchargedeprojets && " " + phonenumberchargedeprojets
        }\n`;
        if (d.direcamion && project.remarques !== "ANNULÉ") {
          message += `Camion : ${project.numerocamion}\n`;
        }
        if (d.direchauffeur && project.remarques !== "ANNULÉ") {
          message += `Chauffeur : ${project.chauffeur ? "OUI" : "NON"}\n`;
        }
        if (d.direchefequipe && project.remarques !== "ANNULÉ") {
          message += `Contremaître : ${project.contremaitre ? "OUI" : "NON"}\n`;
        }
        if (d.direequipe && project.remarques !== "ANNULÉ") {
          message += `Équipe : ${getCollegues(project)}\n`;
        }
        // if (project.remarques) {
        //   message += `Remarques : ${project.remarques}\n`;
        // }
      }
    });
    //Thank you
    message += "Merci";
    //console.log(message);
    return message;
  };
  const updateData = (record, dataIndex, value) => {
    let newPlanifData = [...planifData];
    newPlanifData = newPlanifData.map((employe) => {
      if (employe.key === record.key) {
        employe[dataIndex] = !employe[dataIndex];
        employe.message = buildMessage(employe, planifDate);
        console.log(employe);
        return employe;
      } else {
        return employe;
      }
    });
    setPlanifData(newPlanifData);
    //console.log(record, dataIndex, value);
    //console.log(newPlanifData);
  };
  const saveRecord = (record) => {
    let newPlanifData = [...planifData];
    newPlanifData = newPlanifData.map((employe) => {
      if (employe.key === record.key) {
        return record;
      } else {
        return employe;
      }
    });
    setPlanifData(newPlanifData);
    console.log(newPlanifData);
  };
  const updateSelection = (key, value) => {
    let index = selectedRowKeys.findIndex((element) => element === key);
    let newSelectedRowKeys = [...selectedRowKeys];
    if (index > -1 && value === false) {
      newSelectedRowKeys.splice(index, 1);
    } else if (index === -1 && value === true) {
      newSelectedRowKeys.push(key);
    }
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const selectAll = (selected, selectedRows, changeRows) => {
    if (selected) {
      let newSelectedRowKeys = [...selectedRowKeys];
      changeRows.forEach((row) => {
        newSelectedRowKeys.push(row.key);
      });
      setSelectedRowKeys(newSelectedRowKeys);
    } else {
      setSelectedRowKeys([]);
    }
  };
  const loadFile = async (e) => {
    if (e.fileList.length > 0) {
      setPlanifData(undefined);
      setPlanifDate(undefined);
      setPercentage(0);
      setSendingDone(false);
      setDisabled(false);
      setLoading(true);
      message.loading({
        content: "Veuillez patienter...",
        key: "upload",
        duration: 10,
      });
      let file = await toBase64(e.file);
      setFileName(e.file.name);
      let adresseplanif =
        !process.env.NODE_ENV || process.env.NODE_ENV === "development"
          ? "http://localhost:5001/artext-92d42/us-east1/planif"
          : "https://us-east1-artext-92d42.cloudfunctions.net/planif";
      axios
        .post(adresseplanif, {
          file: file,
          contactChantier: contactChantier,
          contactBureau: contactBureau,
        })
        .then((result) => {
          message.success({
            content: "La planifcation a bien été téléchargée!",
            key: "upload",
            duration: 3,
          });
          //console.log(result);
          //console.log(result.data);
          newPlanifDowloaded(result.data);
          setLoading(false);
        });
    }
  };
  const updateStatus = (destinataire, status) => {
    //let newDestinataires = [...destinataires];
    //let newDestinataire = { ...destinataire, status: status };
    //newDestinataires.splice(index, 1, newDestinataire);
    //setDestinataires(newDestinataires);
    setPlanifData((prevDestinataires) => {
      //console.log(prevDestinataires);
      let index = prevDestinataires.findIndex(
        (item) => destinataire.key === item.key
      );
      let newDestinataires = [...prevDestinataires];
      let newDestinataire = { ...destinataire, status: status };
      newDestinataires.splice(index, 1, newDestinataire);
      return newDestinataires;
    });
    setPercentage((prevPercentage) => {
      let newPercentage = prevPercentage + 100 / selectedRowKeys.length;
      return newPercentage;
    });
  };
  const sendPlanif = () => {
    setDisabled(true);
    var sendMessage = functions.httpsCallable("sendmessage");
    let newPlanifData = [...planifData];
    planifData.forEach((destinataire, index) => {
      if (selectedRowKeys.includes(destinataire.key)) {
        let newDestinataire = { ...destinataire, status: "loading" };
        newPlanifData.splice(index, 1, newDestinataire);
        setPlanifData(newPlanifData);
        sendMessage({
          destinataire: destinataire,
          message: destinataire.message,
        }).then((result) => {
          updateStatus(result.data.destinataire, result.data.message.status);
        });
      }
    });
  };

  const needToSelect = (data) => {
    return data.projects.some((project) => {
      if (settings.sendconge && project === "CONGÉ") {
        return true;
      }
      if (settings.sendoff && project === "OFF") {
        return true;
      }
      if (settings.sendout && project.remarques === "OUT") {
        return true;
      }
      if (settings.sendannule && project.remarques === "ANNULÉ") {
        return true;
      }
      if (settings.sendaconfirmer && project.remarques === "À confirmer") {
        return true;
      }
      if (
        settings.sendoutxjours &&
        project.remarques?.length > 3 &&
        project.remarques?.includes("OUT")
      ) {
        return true;
      }
      if (
        settings.sendretour &&
        project.remarques?.toLowerCase() === "retour"
      ) {
        return true;
      }
      if (project.remarques === "" || project.remarques === ".") {
        return true;
      }
      if (project.remarques?.toLowerCase().includes("combiné")) {
        return true;
      }
    });
  };
  useEffect(() => {
    database.ref("chantierContacts").once("value", (snapshot) => {
      if (snapshot.val()) {
        var firebaseData = Object.values(snapshot.val()).map((item, index) => {
          return {
            key: Object.keys(snapshot.val())[index],
            ...item,
          };
        });
        setContactChantier(firebaseData);
      }
    });
    database.ref("bureauContacts").once("value", (snapshot) => {
      if (snapshot.val()) {
        var firebaseData = Object.values(snapshot.val()).map((item, index) => {
          return {
            key: Object.keys(snapshot.val())[index],
            ...item,
          };
        });
        setContactBureau(firebaseData);
      }
    });
    database.ref("reglages").once("value", (snapshot) => {
      if (snapshot.val()) {
        setSettings(snapshot.val());
        console.log(snapshot.val());
      }
    });
  }, []);
  useEffect(() => {
    if (Math.round(percentage) === 100) {
      message.success({
        content: "Le traitement des messages est terminé!",
      });
      setSendingDone(true);
      if (settings.sendconfirmation) {
        var sendMessage = functions.httpsCallable("sendmessage");
        sendMessage({
          destinataire: { phonenumber: settings.confirmationnumber },
          message: `${selectedRowKeys.length} message${
            selectedRowKeys.length > 1 ? "s ont" : " a"
          } été envoyé${selectedRowKeys.length > 1 ? "s" : ""} automatiquement`,
        });
      }
    }
  }, [percentage]);
  return (
    <CustomLayout
      selectedKey="2"
      contentStyle={{ display: "flex", flexDirection: "column", height: 0 }}
    >
      {!planifData && !loading && (
        <>
          <Title>Planification</Title>
          <div
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div style={{ width: "40%", minWidth: 400 }}>
              <Dragger
                className="planifdragger"
                fileList={[]}
                name="uploadplanif"
                beforeUpload={(file) => {
                  return false;
                }}
                onDownload={() => console.log("onDownload")}
                onChange={(e) => {
                  loadFile(e);
                }}
                listType="picture"
                accept=".pdf"
              >
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                  Cliquez ou déposez le fichier de planification ici
                </p>
                <p className="ant-upload-hint">
                  Le fichier doit être au format PDF
                </p>
              </Dragger>
            </div>
          </div>
        </>
      )}
      {loading && <Spin size="large" className="loader" />}
      {planifData && (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              <Title level={3}>{`${capitalize(
                dayjs(planifDate, "D MMMM YYYY").format("dddd")
              )} ${dayjs(planifDate, "D MMMM YYYY").format("DD")} ${capitalize(
                dayjs(planifDate, "D MMMM YYYY").format("MMMM")
              )} ${dayjs(planifDate, "D MMMM YYYY").format("YYYY")}`}</Title>
              <div>
                <Text underline>{fileName}</Text>
              </div>
            </div>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <Upload
                fileList={[]}
                name="uploadplanif"
                beforeUpload={(file) => {
                  return false;
                }}
                onDownload={() => console.log("onDownload")}
                onChange={(e) => {
                  loadFile(e);
                }}
                listType="picture"
                accept=".pdf"
              >
                <Button type="default">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <FaCloudUploadAlt style={{ marginRight: 5 }} />
                    Nouvelle planification
                  </div>
                </Button>
              </Upload>
              <Button
                type="primary"
                style={{ marginLeft: 10 }}
                danger
                onClick={() => {
                  generatePdf(planifData, planifDate, selectedRowKeys);
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <FaPrint style={{ marginRight: 5 }} />
                  Imprimer la planification
                </div>
              </Button>
              <Button
                type="primary"
                disabled={disabled}
                style={{ marginLeft: 10 }}
                onClick={() => {
                  if (selectedRowKeys.length === 0) {
                    message.error(
                      "La liste de destinataires est vide. Veuillez indiquer au minimum un destinataire."
                    );
                    return;
                  }
                  confirmAlert({
                    title: "Confirmer l'envoi",
                    message: `Êtes-vous certain de vouloir envoyer ${
                      selectedRowKeys.length === 1
                        ? "le message"
                        : `les ${selectedRowKeys.length} messages`
                    } ?`,
                    buttons: [
                      {
                        label: "Oui",
                        onClick: () => sendPlanif(),
                      },
                      {
                        label: "Non",
                        //onClick: () => alert('Click No'),
                      },
                    ],
                  });
                }}
              >
                {sendingDone ? (
                  <CheckOutlined style={{ marginRight: 5 }} />
                ) : disabled ? (
                  <LoadingOutlined
                    style={{ color: "#1DA57A", marginRight: 5 }}
                  />
                ) : (
                  <MailOutlined style={{ marginRight: 5 }} />
                )}
                Envoyer la planification
              </Button>
            </div>
          </div>
          <div style={{ marginBottom: 5, paddingRight: 40, paddingLeft: 40 }}>
            <Progress
              type="line"
              percent={Math.round(percentage)}
              strokeColor="#1DA57A"
              format={(percent) =>
                percent === 100
                  ? "Terminé!"
                  : `${Math.round((percent * selectedRowKeys.length) / 100)}/${
                      selectedRowKeys.length
                    }`
              }
            />
          </div>
          <div style={{ overflow: "auto" }} id="planif-table-div">
            <PlanifTable
              data={planifData}
              contactChantier={contactChantier}
              contactBureau={contactBureau}
              showPopup={showPopup}
              updateData={updateData}
              selectedRowKeys={selectedRowKeys}
              setModalMessageVisible={setModalMessageVisible}
              setModalRecord={setModalRecord}
              updateSelection={updateSelection}
              selectAll={selectAll}
              disabled={disabled}
            />
            <BackTop
              target={() => document.getElementById("planif-table-div")}
            />
          </div>
          {/* <div
            style={{
              flex: 1,
              height: 500,
            }}>
            <div style={{ height: '100%', overflowY: 'scroll' }}>
              <PlanifTable
                data={planifData}
                contactChantier={contactChantier}
                contactBureau={contactBureau}
                showPopup={showPopup}
                updateData={updateData}
                selectedRowKeys={selectedRowKeys}
                setModalMessageVisible={setModalMessageVisible}
                setModalRecord={setModalRecord}
                updateSelection={updateSelection}
                selectAll={selectAll}
                disabled={disabled}
              />
            </div>
          </div>
          <div style={{ paddingLeft: 50, paddingRight: 50, paddingTop: 10 }}>
            <Progress
              type="line"
              percent={Math.round(percentage)}
              strokeColor="#1DA57A"
              format={(percent) =>
                percent === 100
                  ? 'Terminé!'
                  : `${Math.round((percent * selectedRowKeys.length) / 100)}/${
                      selectedRowKeys.length
                    }`
              }
            />
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                paddingTop: 20,
              }}>
              <Button
                type="primary"
                disabled={disabled}
                style={{ width: 300, height: 50, marginRight: 20 }}
                onClick={() => {
                  // if (messageToSend.length === 0) {
                  //   message.error('Veuillez rédiger un message');
                  //   return;
                  // }
                  if (selectedRowKeys.length === 0) {
                    message.error(
                      'La liste de destinataires est vide. Veuillez indiquer au minimum un destinataire.'
                    );
                    return;
                  }
                  confirmAlert({
                    title: "Confirmer l'envoi",
                    message: `Êtes-vous certain de vouloir envoyer ${
                      selectedRowKeys.length === 1
                        ? 'le message'
                        : `les ${selectedRowKeys.length} messages`
                    } ?`,
                    buttons: [
                      {
                        label: 'Oui',
                        onClick: () => sendPlanif(),
                      },
                      {
                        label: 'Non',
                        //onClick: () => alert('Click No'),
                      },
                    ],
                  });
                }}>
                {sendingDone ? (
                  <CheckOutlined style={{ fontSize: 30 }} />
                ) : disabled ? (
                  <LoadingOutlined style={{ color: '#1DA57A', fontSize: 20 }} />
                ) : (
                  <MailOutlined style={{ fontSize: 30 }} />
                )}
              </Button>
            </div>
          </div> */}
          <Popup
            record={actualRecord}
            visible={popupVisible}
            coordinates={popupCoordinates}
          />
          <ModalMessage
            visible={modalMessageVisible}
            onOk={(newModalRecord) => {
              console.log(newModalRecord);
              saveRecord(newModalRecord);
              setModalMessageVisible(false);
            }}
            onCancel={() => {
              setModalMessageVisible(false);
            }}
            modalRecord={modalRecord}
          />
        </>
      )}
    </CustomLayout>
  );
}

function toBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

const capitalize = (s) => {
  if (typeof s !== "string") return "";
  return s.charAt(0).toUpperCase() + s.slice(1);
};

function getCollegues(project) {
  let collegues = [];
  project.collegues.map((camion) => {
    if (camion.remarques !== "ANNULÉ") {
      camion.passagers.map((passager) => {
        collegues.push(
          passager.prenom +
            " " +
            passager.nom.charAt(0).toUpperCase() +
            "." +
            (passager.contremaitre ? " (Contremaître)" : "")
        );
      });
    }
  });
  return collegues.join(", ");
}
